module.exports = __webpack_public_path__ + "img/spinner-solid.399ac2ae.svg";